export const PLAN_FEATURES_SESSION_KEY = 'paidTrialPlanFeaturesShown';

export const PLAN_FEATURES_MAX_SHOWS_PER_SESSION = 3;

export const PLAN_FEATURES_WATCH_SECONDS = 15;

export const MAX_PLAYBACK_STEP_SECONDS = 1.5;
